import { connect } from "react-redux";
import RSVPFrom from "../../RSVPFrom/RSVPFrom";
import Reveal from "../Reveal";
import Section from "./Section";
import { isRsvpEnabled } from "../../../utils";

/** RSVP: the shared RSVPFrom (same fields, validation and API call), styled for the theme. */
const Rsvp = ({ rsvpConfigs, events, pathname }) => {
  if (!isRsvpEnabled(rsvpConfigs)) return null;

  return (
    <Section
      id="rsvp"
      className="rm-rsvp"
      label="RSVP"
      flora="spray-right"
      seed={61}
      kicker="Kindly Respond"
      lead="Your gracious presence is sincerely requested"
    >
      <Reveal className="rm-form" delay={0.1}>
        <RSVPFrom rsvpConfigs={rsvpConfigs} events={events} />
      </Reveal>
      {pathname?.includes("Etasha-Pulkit") && (
        <Reveal className="rm-rsvp__contact" delay={0.15}>
          <p className="rm-rsvp__contact-name">Dev Choudhary</p>
          <p className="rm-rsvp__contact-phone">
            <a href="tel:8094339422">8094339422</a>
          </p>
          <p className="rm-rsvp__contact-org">(Seven Fold Productions)</p>
        </Reveal>
      )}
    </Section>
  );
};

const mapStateToProps = (state) => ({
  rsvpConfigs: state.inviteDetails.invite?.rsvpConfigs,
  events: state.inviteDetails.invite?.events,
  pathname: state.inviteDetails.invite?.pathname,
});

export default connect(mapStateToProps)(Rsvp);
